import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Snackbar, Alert, CircularProgress } from "@mui/material";

const EditChapter = () => {
  const location = useLocation();
  const departmentToEdit = location.state?.chapter;

  const [formValues, setFormValues] = useState({
    department_id: "",
    courseCategory_id: "",
    course_id: "",
    chaptername: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [courseCategories, setCourseCategories] = useState([]);
  const [course, setCourse] = useState([]);
  // snackbar
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchdepartment = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/no-pagination-get-all-department`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setDepartments(response?.data.data);
        // console.log(response?.data.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchdepartment();
  }, []);

  useEffect(() => {
    const fetchCourseCategory = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          // console.log("Access required");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-course-category-bydept/${formValues.department_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCourseCategories(response.data.data);
        // console.log(response.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchCourseCategory();
  }, [formValues.department_id]);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-Courses/${formValues.department_id}/${formValues.courseCategory_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCourse(response.data.data);
        // console.log(response.data);
      } catch (error) {
        // console.log(error);
      }
    };
    fetchCourse();
  }, [formValues.courseCategory_id, formValues.department_id]);

  useEffect(() => {
    // console.log("course to editt: ", departmentToEdit);
    if (departmentToEdit) {
      setFormValues({
        department_id: departmentToEdit.department._id,
        courseCategory_id: departmentToEdit.level._id,
        course_id: departmentToEdit.courses._id,
        chaptername: departmentToEdit.chaptername,
        duration: departmentToEdit.duration,
      });
      setLoading(false); // Stop loading after setting form state
    } else {
      setError("No chapter data found.");
      setLoading(false);
    }
  }, [departmentToEdit]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        // navigate("/login"); // Redirect to login if no token
        return;
      }


      const reqBody = {
        department_id: formValues.department_id,
        courseCategory_id: formValues.courseCategory_id,
        course_id: formValues.course_id,
        chaptername: formValues.chaptername,
      };

      if (departmentToEdit) {
        // const response = await updateStudent(studentToEdit._id, reqBody, reqHeader);
        const response = await axios.put(
          `${process.env.REACT_APP_INSTITUTION_BASEURL}/update-chapter/${departmentToEdit._id}`,
          reqBody,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (response.status === 200) {
          setSnackbarMessage("Updated successfully!");
          setSnackbarSeverity("success");
          setOpenSnackbar(true);
          setTimeout(() => {
            navigate("/chapter-list");
          }, 2000);
        }
        // // console.log("edit: ", response);
      }

      //   navigate("/students");
    } catch (err) {
      setSnackbarMessage("Failed to update. Please try again");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  return (
    <div className="row gy-4">
      <div className="col-lg-8" style={styles.cardContent(loading)}>
        
          
            <div className="card h-100">
              <div className="card-body p-24">
                <form onSubmit={(e)=>handleSubmit(e)}>
                  <div className="mb-20">
                    <label
                      htmlFor="depart"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Department
                      <span className="text-danger-600">*</span>
                    </label>
                    <select
                      className="form-control radius-8 form-select"
                      id="depart"
                      value={formValues.department_id}
                      onChange={(e) =>
                        setFormValues({
                          ...formValues,
                          courseCategory_id: "",
                          course_id: "",
                          department_id: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="" disabled>
                        Select a Department
                      </option>
                      {departments.map((department) => (
                        <option key={department._id} value={department._id}>
                          {department.department_name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="mb-20">
                    <label
                      htmlFor="courseCategory"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Level
                      <span className="text-danger-600">*</span>
                    </label>
                    <select
                      className="form-control radius-8 form-select"
                      id="courseCategory"
                      value={formValues.courseCategory_id}
                      onChange={(e) =>
                        setFormValues({
                          ...formValues,
                          course_id: "",
                          courseCategory_id: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="" disabled>
                        Select Level
                      </option>
                      {courseCategories.map((courseCategory) => (
                        <option
                          key={courseCategory._id}
                          value={courseCategory._id}
                        >
                          {courseCategory.courseCategoryName}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* courseid */}
                  <div className="mb-20">
                    <label
                      htmlFor="courseCategory"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Course
                      <span className="text-danger-600">*</span>
                    </label>
                    <select
                      className="form-control radius-8 form-select"
                      id="courseCategory"
                      value={formValues.course_id}
                      onChange={(e) =>
                        setFormValues({
                          ...formValues,
                          course_id: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="" disabled>
                        Select a course
                      </option>
                      {course.map((courses) => (
                        <option key={courses._id} value={courses._id}>
                          {courses.coursename}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Chapter Name */}
                  <div className="mb-20">
                    <label
                      htmlFor="chaptername"
                      className="form-label fw-semibold text-primary-light text-sm mb-8"
                    >
                      Chapter Name
                      <span className="text-danger-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter chapter name"
                      id="chaptername"
                      className="form-control radius-8"
                      value={formValues.chaptername}
                      onChange={(e) =>
                        {
                          const value = e.target.value;
                          if (value === "" || value.trim() !== "") {
                        setFormValues({
                          ...formValues,
                          chaptername: e.target.value,
                        });
                      }}}
                      required
                    />
                  </div>

                  <div className="d-flex align-items-center justify-content-center gap-3">
                    <button
                      type="button"
                      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                      onClick={() => navigate("/chapter-list")}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                      // onClick={handleSubmit}
                    >
                      {loading && (
         <div className="loader-container" style={styles.loaderContainer}>
                                              <CircularProgress />
                                            </div>
                                          )}
                                            Save
                    </button>
                  </div>
                </form>
              </div>
            
        </div>
      </div>
      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          // variant="filled"
          // sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditChapter;
